import {UiBaseIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "lock-filled" }, [
      _createElementVNode("path", {
        id: "icon",
        fill: "gray",
        "fill-rule": "evenodd",
        d: "M9.832 1.436a5.665 5.665 0 0 1 7.833 5.234V9H18a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h.335V6.67a5.665 5.665 0 0 1 3.497-5.234ZM8.665 9h6.67V6.67a3.335 3.335 0 0 0-6.67 0V9Z",
        "clip-rule": "evenodd"
      })
    ], -1)
  ])))
}
export default { render() { return h(UiBaseIcon, {icon: {render}, name: "lock-filled"}) } }